module.exports = __webpack_public_path__ + "img/58.b61adcbc.jpg";